import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Invite from "./pages/Invite";
import Dashboard from "./pages/Dashboard";
import DashboardDetails from "./pages/DashboardDetails";
import Sales from "./pages/Sales";
import NewSale from "./pages/NewSale";
import Stock from "./pages/Stock";
import ProductDetail from "./pages/ProductDetail";
import Quotes from "./pages/Quotes";
import { Clients, ClientDetail } from "./pages/Clients";
import Suppliers from "./pages/Suppliers";
import Expenses from "./pages/Expenses";
import Employees from "./pages/Employees";
import Team from "./pages/Team";
import Settings from "./pages/Settings";
import More from "./pages/More";
import Admin, { AdminAgentInvite } from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import Payment from "./pages/Payment";
import Onboarding from "./pages/Onboarding";

function Splash() {
  return <div className="min-h-screen flex items-center justify-center"><p className="font-display font-bold text-2xl lowercase animate-pulse">kavizio</p></div>;
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/connexion" replace />;
  const step = user.company?.onboarding_status || "active";
  if (step === "pending_info" || step === "pending_plan" || step === "pending_setup") {
    return <Navigate to="/demarrage" replace />;
  }
  if (user.subscription?.payment_status === "pending") return <Navigate to="/paiement" replace />;
  return children;
}

function RootGate() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (user) return <Navigate to="/accueil" replace />;
  return <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/" element={<RootGate />} />
          <Route path="/tarifs" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/demarrage" element={<Onboarding />} />
          <Route path="/paiement" element={<Payment />} />
          <Route path="/paiement/retour" element={<Payment />} />
          <Route path="/invitation/:token" element={<Invite />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/invitation/:token" element={<AdminAgentInvite />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/accueil" element={<Dashboard />} />
            <Route path="/tableau-detaille" element={<DashboardDetails />} />
            <Route path="/ventes" element={<Sales />} />
            <Route path="/ventes/nouvelle" element={<NewSale />} />
            <Route path="/devis" element={<Quotes />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/stock/:id" element={<ProductDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/fournisseurs" element={<Suppliers />} />
            <Route path="/depenses" element={<Expenses />} />
            <Route path="/employes" element={<Employees />} />
            <Route path="/equipe" element={<Team />} />
            <Route path="/parametres" element={<Settings />} />
            <Route path="/plus" element={<More />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

export default App;
